module.exports = __webpack_public_path__ + "static/innerbanner-ac4fd48a3b76860c13b00060db5e32bc.jpg";